import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: left;
  padding: 0 1em 1em 1em;
  position: absolute;
  bottom: 0;

  h1, h3 {
    text-align: left;
  }
  h3, p, a {
    font-family: 'Work Sans';
    color: white;
    text-decoration
    transiton: .2s;
    -webkit-transition: .2s;
  }
  h1 {
    letter-spacing: 0.1em;
  }
  h3 {
    margin-top: 1em;
    text-transform: capitalize;
  }
  a:hover {
    color: #c3b158;
  }

  @media (min-width: 767px) {
    right: 15%;
    bottom: 20%;

    h3 { font-size: 1.3em; }
    p, a { font-size: 1.3em; }
  }

  @media (min-width: 1200px) {
    right: 30%;
    bottom: 30%;
  }
`;

export default Wrapper;



// WEBPACK FOOTER //
// ./client/components/Contact/Header/Wrapper.js